// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 2739) return "static/chunks/2739-3eb2f7f0427d37d0.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5374":"82f16d27486ff640","8615":"95f4b1f86e4f1105"}[chunkId] + ".js";
};